var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"not-found-page"}},[_c('van-nav-bar',{attrs:{"title":"地址不存在"}}),_c('div',{staticClass:"page-content"},[_c('van-empty',{attrs:{"image":"network","description":"404 Not Found"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }